import { act } from "react";
import CONSTANTS from "./constants";

const initialState = {
  showIntroVideoBottomSheet: false,
  showShareContentViaBottomSheet: false,
  showAboutThisCourseBottomSheet: false,
  showVideoRestrictionsBottomSheet: false,
  showUpcomingLiveClassesBottomSheet: false,
  showApplyCouponBottomSheet: false,
  showApplyBundleBottomSheet: false,
  showApplyBundleReceiptBottomSheet: false,
  showContentLockedBottomSheet: false,
  showWhatAreYouWatchingBottomSheet: false,
  showTestIsLockedBottomSheet: false,
  showSelectStateBottomSheet: false,
  showCourseFacultyListBottomSheet: false,

  showSelectAddressBottomSheet: false,
  showDeleteAddressPopup: false,

  showRunningTightOnBudgetBottomSheet: false,
  showCongratulationsBottomSheet: false,
  congratulationsBottomCard: null,
  isFreeTrialBottomSheetOpenViaTabSwitch: false,
  showDueDateBottomSheet: false,
  showCourseLockedBottomSheet: false,
  showPaymentFailedBottomSheet: false,
  showFreeTrailBottomSheet: false,
  showEnrollForFreeCourseBottomSheet: false,
  showLockedFreeCourseBottomSheet: false,

  showViewsExhaustedBottomSheet: false,
  showDownloadVideoBottomSheet: false,
  showExpirySoonBottomSheet: false,
  showPaymentProcessingBottomSheet: false,
  showTestIsTemporarilyLockedBottomSheet: false,
  showTestIsTemporarilyLockedTimingBottomSheet: false,
  showTestIsTemporarilyLockedTimingBottomSheetDates: {
    startDate: "",
    endDate: "",
  },
  showAnnouncementsAttachments: false,
  showBottomStatesOnce: {
    isShownExpirySoonBottomSheet: false,
    isShowRunningTightOnBudgetBottomSheet: false,
    isShowDueDateBottomSheet: false,
  },
  showFullScreenLoader: false,
  showPaymentLoader: false,

  showRemoveSuggestionsPromt: false,
  showPaymentProcessingPopup: false,

  paymentMethods: null,
  showPaymentMethodsModal: false,
  selectedPaymentMethod: null,

  showCheckoutOptionsBottomSheet: false,
  showCourseAccessRemoveBottomSheet: false,
  showDynamicBundlingBottomSheet: false,
  dynamicBundlingPopup: false,
  socialLinksForShareable:{},
  showNotSupportedBottomsheet : false,
  showMultiPaymentMethodModal: false,
  selectedMultiPaymentMethod: null,
  showCustomVideoPlayer: null,
  videoPlayerContent: {},
  isIdfysLockContentClicked: false,
  isIdysPaymentRejected: false,
};

const setPaymentMethods = (value) => ({
  paymentMethods: value,
});

const setShowPaymentMethodsModal = (value) => ({
  showPaymentMethodsModal: value,
});

const setShowMultiPaymentMethodModal = (value) => ({
  showMultiPaymentMethodModal: value,
});

const setSelectedPaymentMethod = (value) => ({
  selectedPaymentMethod: value,
});

const setSelectedMultiPaymentMethod = (value) => ({
  selectedMultiPaymentMethod: value,
});

const courseFacultyListModalReducer = (value) => ({
  showCourseFacultyListBottomSheet: value,
});

const setShareContentViaBottomSheet = (value) => ({
  showShareContentViaBottomSheet: value,
});
const setAboutThisCourseBottomSheet = (value) => ({
  showAboutThisCourseBottomSheet: value,
});

const setVideoRestrictionsBottomSheet = (value) => ({
  showVideoRestrictionsBottomSheet: value,
});
const setShowIntroVideoBottomSheet = (value) => ({
  showIntroVideoBottomSheet: value,
});

const setUpcomingLiveClassesBottomSheet = (value) => ({
  showUpcomingLiveClassesBottomSheet: value,
});

const setApplyCouponBottomSheet = (value) => ({
  showApplyCouponBottomSheet: value,
});
const setApplyBundleBottomSheet = (value) => ({
  showApplyBundleBottomSheet: value,
});
const setApplyBundleReceiptBottomSheet = (value) => ({
  showApplyBundleReceiptBottomSheet: value,
});

const setContentLockedBottomSheet = (value) => ({
  showContentLockedBottomSheet: value,
});

const setWhatAreYouWatchingBottomSheet = (value) => ({
  showWhatAreYouWatchingBottomSheet: value,
});

const setTestIsLockedBottomSheet = (value) => ({
  showTestIsLockedBottomSheet: value,
});

const setSelectStateBottomSheet = (value) => ({
  showSelectStateBottomSheet: value,
});

const setDynamicBundlingBottomSheet = (value) => ({
  showDynamicBundlingBottomSheet: value,
});

const setSelectAddressBottomSheet = (value) => ({
  showSelectAddressBottomSheet: value,
});

const setDeleteAddressPopup = (value) => ({
  showDeleteAddressPopup: value,
});

const setRunningTightOnBudgetBottomSheet = (value, innerObj) => ({
  showRunningTightOnBudgetBottomSheet: value,
  showBottomStatesOnce: {
    ...innerObj,
    isShowRunningTightOnBudgetBottomSheet: true,
  },
});

const setCongratulationsBottomSheet = ({ show, bottomCard }) => ({
  showCongratulationsBottomSheet: show,
  congratulationsBottomCard: bottomCard,
});

const setDueDateBottomSheet = (value, innerObj) => ({
  showDueDateBottomSheet: value,
  showBottomStatesOnce: {
    ...innerObj,
    isShowDueDateBottomSheet: true,
  },
});

const setCourseLockedBottomSheet = (value) => ({
  showCourseLockedBottomSheet: value,
});

const setPaymentFailedBottomSheet = (value) => ({
  showPaymentFailedBottomSheet: value,
});

const setIsFreeTrialBottomSheetOpenViaTabSwitch = (value) => ({
  isFreeTrialBottomSheetOpenViaTabSwitch: value,
});

const setFreeTrialBottomSheet = (value) => ({
  showFreeTrailBottomSheet: value,
});

const setEnrollForFreeCourseBottomSheet = (value) => ({
  showEnrollForFreeCourseBottomSheet: value,
});

const setShowLockedFreeCourseBottomSheet = (value) => ({
  showLockedFreeCourseBottomSheet: value,
});

const setViewsExhaustedBottomSheet = (value) => ({
  showViewsExhaustedBottomSheet: value,
});
const setCourseAccessRemovedBottomSheet = (value) => ({
  showCourseAccessRemoveBottomSheet: value,
});

const setDownloadVideoBottomSheet = (value) => ({
  showDownloadVideoBottomSheet: value,
});

const setExpirySoonBottomSheet = (value, innerObj) => {
  return {
    showExpirySoonBottomSheet: value,
    showBottomStatesOnce: {
      ...innerObj,
      isShownExpirySoonBottomSheet: true,
    },
  };
};

const setPaymentProcessingBottomSheet = (value) => ({
  showPaymentProcessingBottomSheet: value,
});

const setTestIsTemporarilyLockedBottomSheet = (value) => ({
  showTestIsTemporarilyLockedBottomSheet: value,
});

const setTestIsTemporarilyLockedTimingBottomSheet = (value) => ({
  showTestIsTemporarilyLockedTimingBottomSheet: value,
});
const setTestIsTemporarilyLockedTimingBottomSheetDates = (dates) => ({
  showTestIsTemporarilyLockedTimingBottomSheetDates: { ...dates },
});
const setAnnouncementsAttachmentsBottomSheet = (value) => ({
  showAnnouncementsAttachments: value,
});
const closeAllBottomSheets = () => ({
  ...initialState,
});

const showFullScreenLoaderFn = (value) => ({
  showFullScreenLoader: value,
});

const showPaymentLoaderFn = (value) => ({
  showPaymentLoader: value,
});

const setShowRemoveSuggestionsPromt = (value) => ({
  showRemoveSuggestionsPromt: value,
});

const setPaymentProcessingPopup = (value) => ({
  showPaymentProcessingPopup: value,
});

const setCheckoutOptionsBottomSheet = (value) => ({
  showCheckoutOptionsBottomSheet: value,
});

const setSocialLinksForShareable = (value) => ({
  socialLinksForShareable: value
})

const setShowNotSupportedBottomsheet = (value) => ({
  showNotSupportedBottomsheet: value,
});

const BottomSheetReducer = (state = initialState, action) => {
  // Hydrate showIntroVideoBottomSheet from overview data if present
  if (
    (action?.type === 'GET_OVERVIEW_DATA_SUCCESS' || action?.type === 'SET_OVERVIEW_DATA_DIRECTLY_IN_STORE') &&
    action?.payload?.course?.introVideoData?.showIntroVideoBottomSheet !== undefined
  ) {
    return {
      ...state,
      showIntroVideoBottomSheet: action.payload.course.introVideoData.showIntroVideoBottomSheet,
    };
  }
  switch (action?.type) {
    case CONSTANTS.CLOSE_ALL_BOTTOMSHEET:
      return {
        ...closeAllBottomSheets(),
      };
    case CONSTANTS.BOTTOMSHEET_SHARE_CONTENT_VIA:
      return {
        ...state,
        ...setShareContentViaBottomSheet(action?.payload),
      };
    case CONSTANTS.BOTTOMSHEET_ABOUT_THIS_COURSE:
      return {
        ...state,
        ...setAboutThisCourseBottomSheet(action?.payload),
      };

    case CONSTANTS.BOTTOMSHEET_CHECKOUT_OPTIONS:
      return {
        ...state,
        ...setCheckoutOptionsBottomSheet(action?.payload),
      };

    case CONSTANTS.BOTTOMSHEET_VIDEO_RESTRICTIONS:
      return {
        ...state,
        ...setVideoRestrictionsBottomSheet(action?.payload),
      };

    case CONSTANTS.BOTTOMSHEET_UPCOMING_LIVE_CLASSES:
      return {
        ...state,
        ...setUpcomingLiveClassesBottomSheet(action?.payload),
      };
    case CONSTANTS.BOTTOMSHEET_APPLY_COUPON:
      // console.log("actionValue", action.payload);

      return {
        ...state,
        ...setApplyCouponBottomSheet(action?.payload),
      };
    case CONSTANTS.BOTTOMSHEET_APPLY_BUNDLE:
      console.log("bundleap", action.payload);

      return {
        ...state,
        ...setApplyBundleBottomSheet(action?.payload),
      };
    case CONSTANTS.BOTTOMSHEET_APPLY_BUNDLE_RECEIPT:
      return {
        ...state,
        ...setApplyBundleReceiptBottomSheet(action?.payload),
      };
    case CONSTANTS.BOTTOMSHEET_CONTENT_LOCKED:
      return {
        ...state,
        ...setContentLockedBottomSheet(action?.payload),
      };
    case CONSTANTS.BOTTOMSHEET_WHAT_ARE_YOU_WATCHING:
      return {
        ...state,
        ...setWhatAreYouWatchingBottomSheet(action?.payload),
      };

    case CONSTANTS.BOTTOMSHEET_TEST_IS_LOCKED:
      return {
        ...state,
        ...setTestIsLockedBottomSheet(action?.payload),
      };

    case CONSTANTS.BOTTOMSHEET_SELECT_STATE:
      return {
        ...state,
        ...setSelectStateBottomSheet(action?.payload),
      };

    case CONSTANTS.BOTTOMSHEET_SELECT_DYNAMIC_BUNDLING:
      return {
        ...state,
        ...setDynamicBundlingBottomSheet(action?.payload),
      };
    case CONSTANTS.BOTTOMSHEET_SELECT_ADDRESS:
      return {
        ...state,
        ...setSelectAddressBottomSheet(action?.payload),
      };

    case CONSTANTS.POPUP_DELETE_ADDRESS:
      return {
        ...state,
        ...setDeleteAddressPopup(action?.payload),
      };

    case CONSTANTS.BOTTOMSHEET_RUNNING_TIGHT_ON_BUDGET:
      return {
        ...state,
        ...setRunningTightOnBudgetBottomSheet(
          action?.payload,
          state.showBottomStatesOnce
        ),
      };

    case CONSTANTS.BOTTOMSHEET_CONGRATULATIONS:
      return {
        ...state,
        ...setCongratulationsBottomSheet(action?.payload),
      };

    case CONSTANTS.BOTTOMSHEET_DUE_DATE:
      return {
        ...state,
        ...setDueDateBottomSheet(action?.payload, state.showBottomStatesOnce),
      };

    case CONSTANTS.BOTTOMSHEET_COURSE_LOCKED:
      return {
        ...state,
        ...setCourseLockedBottomSheet(action?.payload),
      };

    case CONSTANTS.BOTTOMSHEET_PAYMENT_FAILED:
      return {
        ...state,
        ...setPaymentFailedBottomSheet(action?.payload),
      };

    case CONSTANTS.BOTTOMSHEET_FREE_TRIAL_OPEN_VIA_TAB_SWITCH:
      return {
        ...state,
        ...setIsFreeTrialBottomSheetOpenViaTabSwitch(action?.payload),
      };

    case CONSTANTS.BOTTOMSHEET_FREE_TRAIL:
      return {
        ...state,
        ...setFreeTrialBottomSheet(action?.payload),
      };

    case CONSTANTS.BOTTOMSHEET_ENROLL_FOR_FREE_COURSE:
      return {
        ...state,
        ...setEnrollForFreeCourseBottomSheet(action?.payload),
      };

    case CONSTANTS.BOTTOMSHEET_LOCKED_FREE_COURSE:
      return {
        ...state,
        ...setShowLockedFreeCourseBottomSheet(action?.payload),
      };

    case CONSTANTS.BOTTOMSHEET_VIEWS_EXHAUSTED:
      return {
        ...state,
        ...setViewsExhaustedBottomSheet(action?.payload),
      };
    case CONSTANTS.BOTTOMSHEET_VIEW_COURSE_ACCESS_REMOVED:
      return {
        ...state,
        ...setCourseAccessRemovedBottomSheet(action?.payload),
      };
    case CONSTANTS.BOTTOMSHEET_DOWNLOAD_VIDEO:
      return {
        ...state,
        ...setDownloadVideoBottomSheet(action?.payload),
      };
    case CONSTANTS.BOTTOMSHEET_EXPIRY_SOON:
      return {
        ...state,
        ...setExpirySoonBottomSheet(
          action?.payload,
          state.showBottomStatesOnce
        ),
      };

    case CONSTANTS.BOTTOMSHEET_PAYMENT_PROCESSING:
      return {
        ...state,
        ...setPaymentProcessingBottomSheet(action?.payload),
      };

    case CONSTANTS.BOTTOMSHEET_TEST_IS_TEMPORARILY_LOCKED:
      return {
        ...state,
        ...setTestIsTemporarilyLockedBottomSheet(action?.payload),
      };

    case CONSTANTS.BOTTOMSHEET_TEST_IS_TEMPORARILY_LOCKED_TIMING:
      return {
        ...state,
        ...setTestIsTemporarilyLockedTimingBottomSheet(action?.payload),
        ...setTestIsTemporarilyLockedTimingBottomSheetDates(action?.dates),
      };
    case CONSTANTS.BOTTOMSHEET_ANNOUNCEMENTS_ATTACHMENTS:
      return {
        ...state,
        ...setAnnouncementsAttachmentsBottomSheet(action?.payload),
      };
    // case CONSTANTS.BOTTOMSHEET_IS_SHOW_TIGHT_ON_BUDGET:
    //   return {
    //     ...state,
    //     ...showTightOnBudgetBottomSheet(state.showBottomStatesOnce),
    //   };

    case CONSTANTS.SHOW_FULLSCREEN_LOADER:
      return {
        ...state,
        ...showFullScreenLoaderFn(action?.payload),
      };

    case CONSTANTS.SHOW_PAYMENT_LOADER:
      return {
        ...state,
        ...showPaymentLoaderFn(action?.payload),
      };

    case CONSTANTS.POPUP_REMOVE_SUGGESTIONS:
      return {
        ...state,
        ...setShowRemoveSuggestionsPromt(action?.payload),
      };

    case CONSTANTS.SHOW_POPUP_PAYMENT_PROCESSING:
      return {
        ...state,
        ...setPaymentProcessingPopup(action?.payload),
      };
    case CONSTANTS.BOTTOMSHEET_PAYMENT_METHODS_MODAL:
      return {
        ...state,
        ...setShowPaymentMethodsModal(action?.payload),
      };
    case CONSTANTS.BOTTOMSHEET_MULTI_PAYMENT_METHOD_MODAL:
      return {
        ...state,
        ...setShowMultiPaymentMethodModal(action?.payload),
      };
    case CONSTANTS.BOTTOMSHEET_PAYMENT_METHODS_SET:
      return {
        ...state,
        ...setPaymentMethods(action?.payload),
      };
    case CONSTANTS.BOTTOMSHEET_PAYMENT_METHODS_SELECT:
      return {
        ...state,
        ...setSelectedPaymentMethod(action?.payload),
      };
    case CONSTANTS.BOTTOMSHEET_MULTI_PAYMENT_METHODS_SELECT:
      return {
        ...state,
        ...setSelectedMultiPaymentMethod(action?.payload),
      };
    case CONSTANTS.BOTTOMSHEET_COURSE_FACULTY_LIST:
      return {
        ...state,
        ...courseFacultyListModalReducer(action?.payload),
      };
      case CONSTANTS.SET_SHOW_NOT_SUPPORTED_BOTTOMSHEET:
        return {
          ...state,
          ...setShowNotSupportedBottomsheet(action?.payload),
        };
    case CONSTANTS.DYNAMIC_BUNDLING_POPUP:
      return {
        ...state,
        dynamicBundlingPopup: action?.payload,
      };
      case CONSTANTS.SET_SOCIAL_LINKS_DATA:
        return {
          ...state,
          socialLinksForShareable: action?.payload,
        };
    case CONSTANTS.TOGGLE_VIDEO_BOTTOM_SHEET:
      return {
        ...state,
        showCustomVideoPlayer: action?.payload.value,
        videoPlayerContent: action?.payload?.data
      };
    case CONSTANTS.IDFYS_LOCK_CONTENT:
      return {
        ...state,
        isIdfysLockContentClicked: action?.payload,
      };
    case CONSTANTS.IS_PAYMENT_REJECTED:
      return {
        ...state,
        isIdysPaymentRejected: true,
    }
    case CONSTANTS.SET_SHOW_INTRO_VIDEO_BOTTOM_SHEET:
      return {
        ...state,
        ...setShowIntroVideoBottomSheet(action?.payload),
      };
    default:
      return state;
  }
};

export default BottomSheetReducer;
